export const eur = (n) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const lineUnitPrice = (item) => {
  if (item.variant_index != null && item.product.variants?.[item.variant_index]) {
    return Number(item.product.variants[item.variant_index].price);
  }
  return Number(item.product.price);
};
